export const HOMEWORK_STATE = {
  1: { tone: 'new', done: false },
  2: { tone: 'progress', done: false },
  3: { tone: 'late', done: false },
  4: { tone: 'done', done: true },
};
